import { z } from 'zod';

export const providerConfigSchema = z.object({
  vehicle: z.object({
    events_display: z.boolean(),
    doors_status_display: z.boolean(),
    charge_percentage_display: z.boolean(),
    charge_status_display: z.boolean(),
  }),
  mission: z.object({
    websocket_enabled: z.boolean(),
    progress_display: z.boolean(),
    estimated_duration_display: z.boolean(),
    estimated_distance_display: z.boolean(),
    waypoints_enabled: z.boolean(),
    activity_enabled: z.boolean(),
  }),
  shift: z.object({
    can_be_paused: z.boolean(),
  }),
});

export type ProviderConfig = z.infer<typeof providerConfigSchema>;
